import React, { Suspense } from "react";
import { useTranslate } from "@tolgee/react";
import { usePageInit } from "src/common/hooks";
import { Loading } from "src/components";

const UpcomingTripsItinerary = React.lazy(
  () => import("./UpcomingTripsItinerary"),
);

function UpcomingTripsItineraryPage(props) {
  const { t } = useTranslate();
  usePageInit(
    t({
      key: "upcomingTrips.itinerary.pageTitle",
      defaultValue: "CTM Portal - Itinerary",
    }),
  );
  return (
    <Suspense
      fallback={
        <Loading
          addContainer
          active
          loadingText={t({
            key: "upcomingTrips.modal.loading",
            defaultValue: "Loading Itinerary...",
          })}
        />
      }
    >
      <UpcomingTripsItinerary {...props} />
    </Suspense>
  );
}

export default UpcomingTripsItineraryPage;
